import React from 'react';
import { Card, CardContent, Typography, IconButton, Avatar, Box, Button } from '@mui/material'; 
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'; 

const TaskItem = ({ task, handleDelete, handleEdit, toggleComplete, onGetAIHelp }) => { 
  const generateAvatarUrl = (firstName, lastName) =>
    `https://avatar.iran.liara.run/username?username=${encodeURIComponent(`${firstName || ''} ${lastName || ''}`)}`;

  const avatarUrl = generateAvatarUrl(task.firstName, task.lastName);

  return (
    <Card sx={{
      margin: '10px 0',
      backgroundColor: task.completed ? '#e0ffe0' : '#fff',
      boxShadow: 1
    }}>
      <CardContent sx={{ display: 'flex', alignItems: 'center', p: 2 }}>
        <Avatar alt={task.title} src={avatarUrl} sx={{ mr: 2 }} />
        <Box sx={{ flexGrow: 1 }}>
          <Typography
            variant="h6"
            component="div"
            sx={{
              textDecoration: task.completed ? 'line-through' : 'none',
              color: task.completed ? 'text.disabled' : 'text.primary'
            }}
          >
            {task.title}
          </Typography>
          <Typography variant="body2" color="text.secondary">{task.description}</Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
        
          {!task.completed && onGetAIHelp && ( 
            <Button
              variant="outlined"
              color="primary"
              size="small"
              startIcon={<HelpOutlineIcon />}
              onClick={() => onGetAIHelp(task)} 
              sx={{ mr: 1 }}
            >
              AI Help
            </Button>
          )}

          <IconButton onClick={() => toggleComplete(task.id)} aria-label="toggle complete">
            <CheckCircleIcon color={task.completed ? 'success' : 'action'} />
          </IconButton>
          <IconButton onClick={() => handleEdit(task.id)} aria-label="edit task">
            <EditIcon color="action" />
          </IconButton>
          <IconButton onClick={() => handleDelete(task.id)} aria-label="delete task">
            <DeleteIcon color="error" />
          </IconButton>
        </Box>
      </CardContent>
    </Card>
  );
};

export default TaskItem;
